import React from "react";
import { Divider, Stack, useViewport } from "@bookingcom/bui-react";
import useModalDialog from "../../../hooks/useModalDialog.js";
import { useRef } from "react";
import NotAvailableIllustration from "../../../assets/illustrations/not-available.svg";
import ErrorAlert from "../ErrorAlert/index.js";
import Timeline from "../Timeline/index.js";
import FlightsContentSkeleton from "./components/FlightsContentSkeleton.js";
import { ShareFlight } from "../ShareFlight/index.js";
import Frame from "../Frame/index.js";
import styles from "./FlightDetailsInner.desktop.module.css";
import { FlightDetailsCampaignBadgeSection } from "./components/FlightDetailsCampaignBadgeSection.js";
import AriaLive from "../AriaLive/index.js";
import { WishlistWidgetWrapper } from "../WishlistWidgetWrapper/index.js";
import FlightDetailsInfoDesktop from "./components/FlightDetailsInfo/FlightDetailsInfo.desktop.js";
import { SurveyTrackerLoader } from "../../remote/SurveyTrackerFlightsUniversal.js";
import { useFlightDetailsInnerDesktopController } from "./useFlightDetailsInner.desktop.controller.js";
import { useFlightDetailsInnerEffectsDesktop } from "./useFlightDetailsInnerEffects.desktop.js";
import FlightDetailsFooterDesktop from "./FlightDetailsFooter.desktop.js";
import { FlightsFunnelNewFdPageDesktopTracker } from "../../../utils/experiments/funnel/flights_funnel_new_fd_page_desktop.js";
const FlightDetailsInnerDesktop = ({ flightToken, flight, fetchStatus, onClose, onErrorClose, closeAriaLabel, hasPrefetchedBrandedFareOffers, alternativeFaresFlow }) => {
    const Modal = useModalDialog();
    const { isLarge, isSmall } = useViewport();
    const scrollableRef = useRef(null);
    const { isError, isModalOpen, modalTitle, shouldShowWishlistWidget, campaignBadges, onFlightSelect, onModalClose, isLoggedInAuthLow, trackV2, flightDetailsFetchStatus, isRetryableFlightDetails, errorTitle, errorBody, errorButtonLabel } = useFlightDetailsInnerDesktopController({
        flightToken,
        flight,
        fetchStatus,
        onClose,
        alternativeFaresFlow,
        hasPrefetchedBrandedFareOffers
    });
    useFlightDetailsInnerEffectsDesktop({
        flightToken,
        flight,
        fetchStatus,
        isError,
        trackV2,
        flightDetailsFetchStatus,
        isRetryableFlightDetails
    });
    if (isError) {
        return (React.createElement(ErrorAlert, { illustration: React.createElement(NotAvailableIllustration, null), title: errorTitle, body: errorBody, buttonLabel: errorButtonLabel, onClick: onErrorClose }));
    }
    const alignItems = shouldShowWishlistWidget ? "center" : "start";
    const stackPaddingBlockEnd = shouldShowWishlistWidget ? 2 : 0;
    const stackGap = campaignBadges.length > 0 ? 2 : 4;
    return (React.createElement(Modal, { attributes: { "data-js-fd-modal-root": "true" }, overlayAttributes: !isLarge ? { id: "overlay-sm" } : undefined, active: isModalOpen, onCloseTrigger: onModalClose, size: "large", title: modalTitle, position: "center", closeAriaLabel: closeAriaLabel, className: isSmall ? styles.modalSm : "" },
        React.createElement(React.Fragment, null,
            flight ? React.createElement(FlightsFunnelNewFdPageDesktopTracker, { flight: flight }) : undefined,
            flight ? (React.createElement("div", { "data-testid": "flightdetails_sheet", ref: scrollableRef },
                React.createElement(Stack, { direction: "row", alignItems: alignItems, mixin: { paddingBlockEnd: stackPaddingBlockEnd }, gap: stackGap },
                    campaignBadges.length > 0 && React.createElement(FlightDetailsCampaignBadgeSection, { campaignBadges: campaignBadges }),
                    flight.offerKeyToHighlight && shouldShowWishlistWidget ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: campaignBadges.length === 0 ? styles.withMargin : "" },
                            React.createElement(WishlistWidgetWrapper, { flight: flight })),
                        React.createElement(ShareFlight, { flight: flight }))) : (React.createElement(Stack.Item, null,
                        React.createElement(Frame, { mb: 4 },
                            React.createElement(ShareFlight, { flight: flight }))))),
                React.createElement(Timeline, { segments: flight.segments }),
                React.createElement(Stack, { gap: 4, mixin: { paddingBlockEnd: 4 } },
                    React.createElement(Divider, null),
                    React.createElement(FlightDetailsInfoDesktop, { flight: flight, fetchStatus: fetchStatus })),
                fetchStatus === "success" && React.createElement(SurveyTrackerLoader, null))) : (React.createElement(FlightsContentSkeleton, null)),
            React.createElement(FlightDetailsFooterDesktop, { flight: flight, onButtonClick: onFlightSelect, fetchStatus: fetchStatus, isLoggedInAuthLow: isLoggedInAuthLow }),
            React.createElement(AriaLive, null))));
};
export default FlightDetailsInnerDesktop;
